import { formatRenewalCurrency } from '../renewalReview';
import { RenewalReviewCard, RenewalReviewField, RenewalReviewLockNote } from './RenewalReviewCard';

export type RenewalEquipmentData = {
  equipment_type?: string;
  manufacturer?: string;
  model?: string;
  year_of_manufacture?: number | string;
  equipment_value?: number;
};

/** Card «Dados do equipamento»: só leitura (Figma 2086:8484). */
export default function RenewalEquipmentCard({ appId, data }: { appId: string; data: RenewalEquipmentData }) {
  return (
    <RenewalReviewCard appId={appId} title="Dados do equipamento">
      <RenewalReviewField label="Tipo" value={data.equipment_type || '—'} />
      <RenewalReviewField label="Marca" value={data.manufacturer || '—'} />
      <RenewalReviewField label="Modelo" value={data.model || '—'} />
      <RenewalReviewField
        label="Ano de fabricação"
        value={data.year_of_manufacture ? String(data.year_of_manufacture) : '—'}
      />
      <RenewalReviewField label="Valor do equipamento" value={formatRenewalCurrency(data.equipment_value)} />
      <RenewalReviewLockNote divider message="Para alterar os dados fale com o atendimento" />
    </RenewalReviewCard>
  );
}
